import React, {Component} from 'react';
import {roundigFormat} from '../libs/utils/Operations';
import moment from 'moment';
import '../css/dataTables.css';
import { Modules } from '../libs/utils/Const';


const renderTableBody = (headers, data, action, groupNumModal) => {
    let body: "";

    body = data.map((register, index) => {

        return (
            <tr key={index}>
                <td>{register.PymntGroup || ""}</td>
                <td style={{textAlign:"center", width:100}}>
                    <button type="button" className="btn btn-sm "
                            onClick={() => action({index})}
                            style={{fontWeight: '500', backgroundColor: "transparent", color: "#EABF28"}}>
                        <i className="fas fa-check"></i>
                    </button>
                    {(!!groupNumModal && Modules.PaymentTerms) &&
                        <button type="button" className="btn btn-outline-warning border-0 ml-2" onClick={() => groupNumModal(register.GroupNum)}>
                            Detalles
                        </button>
                    }
                </td>
            </tr>
        )
    })

    return body;
};

const renderTable = (headers, data, action, groupNumModal) => {
    let header = "";
    let body = "";

    if (headers.length != 0) {
        header = <tr>
            <td className="sticky-header table-header-yellow ">{headers[0].title}</td>
            <td className="sticky-header table-header-yellow " style={{width:100}}></td>
        </tr>;
    }

    body = renderTableBody(headers, data, action, groupNumModal);

    let table = "";

    table =
        <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table id="dataTableCreate" className="display" style={{width: '100%'}}>
                <thead className="table-header">
                {header}
                </thead>
                <tbody>
                {body}
                </tbody>
            </table>
        </div>;

    return table;

};

export const renderGroupNumModal = (headers, data, action, groupNumModal) => {

    return renderTable(headers, data, action, groupNumModal);

}
